import { css } from 'emotion'
import { SUCCESS_COLOR } from 'constants/styleConstants'

export const SuccessMessageStyles = css`
  font-size: 0.75em;
  font-style: italic;
  color: ${SUCCESS_COLOR};
  transition: height 0.1s ease-in-out;
`
